// import Img1 from "./Icon/blog1Img1.jpeg";
// import Img2 from "./Icon/blogImg2.jpeg";
// import Img3 from "./Icon/blog3Img.jpeg";
// import Img4 from "./Icon/blog41.jpeg";
// import Img5 from "./Icon/blog51.jpeg";
// import Img6 from "./Icon/blog61.jpeg";
// import Img7 from "./Icon/blog1Img1.jpeg";
// import Img8 from "./Icon/img8.jpeg";
// const cardData2 = [
//   {
//     card_id: 1,
//     title: "Police Departments Register Complaints via WhatsApp - Simple Guide",
//     tags: ["Remote Work", "Webinar"],
//     card_image: Img1,
//     category: "categoryA",
//   },
//   {
//     card_id: 2,
//     title: "Transform Car Dealerships with WhatsApp API",
//     tags: ["Agile Practices", "Teamwork"],
//     card_image: Img2,
//     category: "categoryA",
//   },
//   {
//     card_id: 3,
//     title: "WhatsApp Business API vs. Google & Facebook Ads for Data Insights",
//     tags: ["Productivity", "Webinar"],
//     card_image: Img3,
//     category: "categoryA",
//   },
//   {
//     card_id: 4,
//     title: "Hidden struggles in higher education can be solved by WhatsApp API",
//     tags: ["Leadership", "Webinar"],
//     card_image: Img4,
//     category: "categoryB",
//   },

// ];

// export default cardData2;

import Img1 from "./Icon/blog1Img1.jpeg";
import Img2 from "./Icon/blogImg2.jpeg";
import Img3 from "./Icon/blog3Img.jpeg";
import Img4 from "./Icon/blog41.jpeg";
import Img5 from "./Icon/blog51.jpeg";
import Img6 from "./Icon/blog61.jpeg";
import Img7 from "./Icon/blog1Img1.jpeg";
import Img8 from "./Icon/img8.jpeg";

const cardData2 = [
  {
    card_id: 1,
    title: "Police Departments Register Complaints via WhatsApp - Simple Guide",
    tags: ["Remote Work", "Webinar"],
    card_image: Img1,
    category: "categoryA",
  },
  {
    card_id: 2,
    title: "Transform Car Dealerships with WhatsApp API",
    tags: ["Agile Practices", "Teamwork"],
    card_image: Img2,
    category: "categoryA",
  },
  {
    card_id: 3,
    title: "WhatsApp Business API vs. Google & Facebook Ads for Data Insights",
    tags: ["Productivity", "Webinar"],
    card_image: Img3,
    category: "categoryA",
  },
  {
    card_id: 4,
    title: "Hidden struggles in higher education can be solved by WhatsApp API",
    tags: ["Leadership", "Webinar"],
    card_image: Img4,
    category: "categoryB",
  },
  {
    card_id: 5,
    title: "Boost E-commerce Sales with WhatsApp API",
    tags: ["E-commerce", "Marketing"],
    card_image: Img5,
    category: "categoryB",
  },
  {
    card_id: 6,
    title: "How WhatsApp API Enhances Customer Support",
    tags: ["Customer Service", "Webinar"],
    card_image: Img6,
    category: "categoryA",
  },
  {
    card_id: 7,
    title: "Streamline Business Operations with WhatsApp",
    tags: ["Operations", "Efficiency"],
    card_image: Img7,
    category: "categoryB",
  },
  {
    card_id: 8,
    title: "View All Articles",
    isViewAll: true,
 }

];

export default cardData2;
